export function escapeLineBreak (str: string): string {
  const newStr = str.replace(/\r\n/g, '<app-rn>')
  return newStr.replace(/\n/g, '<app-n>')
}

export function unescapeLineBreak (str: string): string {
  const newStr = str.replace(/<app-rn>/g, '\r\n')
  return newStr.replace(/<app-n>/g, '\n')
}
